import React, { useState, useEffect } from 'react'
import './Article.css'
import { Link } from 'react-router-dom'

import Facebook from '../assets/logos_facebook.svg'
import Twitter from '../assets/fa6-brands_square-x-twitter.svg'
import Linkedin from '../assets/skill-icons_linkedin.svg'
import Link1 from '../assets/Link.svg'
import A1 from '../assets/A1.webp'
import A2 from '../assets/A2.webp'

import Post1 from '../assets/Post1.webp'
import Post2 from '../assets/Post2.webp'
import Post3 from '../assets/Post3.webp'


import Post11 from '../assets/Post11.webp'
import Post12 from '../assets/Post12.webp'
import Post13 from '../assets/Post13.webp'
import Post14 from '../assets/Post14.webp'
import Post15 from '../assets/Post15.webp'
import Post16 from '../assets/Post16.webp'
import Post17 from '../assets/Post17.webp'
import Post18 from '../assets/Post18.webp'
import Post19 from '../assets/Post19.webp'
import Post110 from '../assets/Post110.webp'
import Post111 from '../assets/Post111.webp'
import Post112 from '../assets/Post112.webp'
import Post113 from '../assets/Post113.webp'
import Post114 from '../assets/Post114.webp'
import Post115 from '../assets/Post115.webp'

import { motion as m } from "framer-motion";
import TopBar from '../components/TopBar'
import Footer from '../components/Footer'
import { useTranslation } from 'react-i18next'
import Carousel from '../components/Carousel'

const images = [
    Post11,Post12,Post13,Post14,Post15,Post16,Post17,Post18,Post19,Post110,Post111,Post112,Post113,Post114,Post115];

const Article1 = () => {
    
  const { i18n } = useTranslation();
  const { t } = useTranslation();
    //media query
    const [deviceWidth, setDeviceWidth] = useState(window.screen.width);

    useEffect(() => {
        const handleResize = () => {
            setDeviceWidth(window.screen.width);
        };
        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
        };
    }, []);
    return (
        <m.div
            className="Article"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: .25 }}
        >
            {/* <TopBar /> */}
            <div className="Article-page">
                <div className="Article-main">
                    <div className="Article-header">
                        <div className="Article-header-top">
                            <div className="Article-header-top-breadcrumb">
                            <Link to="/news"> <div className="Article-header-top-breadcrumb-text1">{t('NewsP1')}</div></Link>
                               {/* <div className="Article-header-top-breadcrumb-text2">5 key generative AI use cases in insurance distribution</div>*/}
                            </div>
                            {deviceWidth > 768 &&
                                <div className="Article-header-top-date">Mar 30,2024</div>}
                        </div>
                        {/*<div className="Article-info">
                            <p className="Article-info-title">5 key generative AI use cases in insurance distribution</p>
                            {deviceWidth >= 768 &&
                                (<div className="Article-author-top-right">
                                    <div className="Article-author-top-right-social">
                                        <img loading="lazy" decoding="async" alt="" src={Facebook} className="Article-author-top-right-social-icon" />
                                    </div>
                                    <div className="Article-author-top-right-social">
                                        <img loading="lazy" decoding="async" alt="" src={Twitter} className="Article-author-top-right-social-icon" />
                                    </div>
                                    <div className="Article-author-top-right-social">
                                        <img loading="lazy" decoding="async" alt="" src={Linkedin} className="Article-author-top-right-social-icon" />
                                    </div>
                                    <div className="Article-author-top-right-social">
                                        <img loading="lazy" decoding="async" alt="" src={Link1} className="Article-author-top-right-social-icon" />
                                    </div>
                                </div>
                                )}
                            </div>*/}

                    </div>

                    <img loading="lazy" decoding="async" alt="" src={Post1} className="Article-main-image" />

                    <div className="Article-main-text">
                    Sharing with you some photos from our latest seminar! It was a wonderful day filled with knowledge exchange and valuable connections. Thanks to everyone who participated and contributed to the success of this event. We hope these snapshots bring back pleasant memories of our gathering!
                      </div>

                      <Carousel images={images}/>

                </div>

                <div className="Article-rec">
                    <p className="Article-rec-header">{t("NewsP3")}</p>
                    <div className="Article-rec-bottom">

                    <Link to='/article1'>
                        <div className="Article-rec-element">

                            <img loading="lazy" decoding="async" alt="" src={Post1} className="Article-rec-element-img" />
                            <div className="Article-rec-element-info">
                                <div className="Article-rec-element-info-top">
                                    {/*<p className="Article-rec-element-info-top-header-name">5 key generative AI use cases in insurance distribution</p>*/}
                                    <div className="Article-rec-element-info-top-header-text">
                                    Sharing with you some photos from our latest seminar! It was a wonderful day filled with knowledge exchange and valuable connections. Thanks to everyone who
                                    </div>
                                </div>
                                <p className="Article-rec-element-info-bottom-frame-time">Mar 6,2024</p>

                            </div>
                        </div></Link>

                        <Link to='/article2'>
                        <div className="Article-rec-element">

                            <img loading="lazy" decoding="async" alt="" src={Post2} className="Article-rec-element-img" />
                            <div className="Article-rec-element-info">
                                <div className="Article-rec-element-info-top">
                                    {/*<p className="Article-rec-element-info-top-header-name">5 key generative AI use cases in insurance distribution</p>*/}
                                    <div className="Article-rec-element-info-top-header-text">
                                    On March 5th, Khamsa Insurance and Reinsurance Brokers LLC, with the support of the Azerbaijan Banks Association and the British Chamber of Commerce Azerbaijan (BCCA), hosted a seminar titled "Secure the Boundaries" focusing on "Cyber Insurance and Directors and Officers (D&O) Insurance."
                                    </div>
                                </div>
                                <p className="Article-rec-element-info-bottom-frame-time">Mar 6,2024</p>

                            </div>
                        </div></Link>


                        <Link to='/article3'>
                        <div className="Article-rec-element">

                            <img loading="lazy" decoding="async" alt="" src={Post3} className="Article-rec-element-img" />
                            <div className="Article-rec-element-info">
                                <div className="Article-rec-element-info-top">
                                     {/*<p className="Article-rec-element-info-top-header-name">5 key generative AI use cases in insurance distribution</p>*/}
                                    <div className="Article-rec-element-info-top-header-text">
                                    Dear Partners,
On 29 January, Khamsa Insurance and Reinsurance Brokers held an important event on "Safe Steps to Foundation in Post-Conflict Areas" at the initiative of the Central Bank of the Republic of Azerbaijan and with support of the Azerbaijan Insurers
                                    </div>
                                </div>
                                <p className="Article-rec-element-info-bottom-frame-time">Jan 30,2024</p>

                            </div>
                        </div></Link>

                    </div>
                </div>
            </div>
            <Footer />
        </m.div>
    )
}

export default Article1